import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { siteTypesEnum } from '../../../../helpers';
import { useRootSelector } from '../../../../store/hooks';
import { selectPageConfig } from '../../../../store/features/pageConfig';
import SiteLayout from '../../../layouts/SiteLayout/SiteLayout';
import HeadingSection from '../../../siteBaseSections/HeadingSection/HeadingSection';
import { selectSiteHeader } from '../../../../store/features/siteHeader';
import { selectSiteContent } from '../../../../store/features/siteContent';
import { selectHubDiscovery } from '../../../../store/features/discovery';
import { DiscoveryContentTypes } from '../../../../constants';
import SiteSearchPageLayout from '../../../layouts/SiteSearchPageLayout';

const { COURSE } = siteTypesEnum();

export default function SearchView() {
  const { t } = useTranslation();
  const { siteType } = useRootSelector(selectPageConfig);
  const siteHeader = useRootSelector(selectSiteHeader);
  const siteContent = useRootSelector(selectSiteContent);

  const {
    data: { facets, records },
  } = useRootSelector(selectHubDiscovery);

  const {
    meta: { title: metaTitle },
  } = siteHeader;

  const {
    details: { searchQueryData, pageTitle, titleSize, showPageHeader } = {},
  } = siteContent;

  const defaultTitle = t(
    siteType === COURSE ? 'course.search' : 'event.search',
  );

  const defaultValues = useMemo(
    () => ({
      type: [DiscoveryContentTypes.ALL],
      page: 1,
      count: 20,
      searchInput: '',
      pageNames: [],
      streamNames: [],
      categoryNames: [],
    }),
    [],
  );

  return (
    // @ts-ignore
    <SiteLayout
      helmet={{
        title: metaTitle || defaultTitle,
      }}
    >
      {showPageHeader && (
        <HeadingSection
          title={pageTitle || defaultTitle}
          titleSize={titleSize}
          largeContainer
        />
      )}
      <SiteSearchPageLayout
        facets={facets}
        records={records}
        defaultValues={defaultValues}
        searchQueryData={searchQueryData}
      />
    </SiteLayout>
  );
}
